import { XIcon } from "@phosphor-icons/react/X";
import { Banner } from "@freightsimple/ui-core/Display/Banner";

// Bare dismiss X, no background. Same grey as the banner's message text
// (Banner.tsx uses #707070 — "var(--color-content-muted)" is too light against gold).
// Nudged up/right so it sits into the corner, outside the banner's inner
// padding.
const dismissButtonClasses =
  "relative -top-[2px] -right-[4px] flex cursor-pointer items-center justify-center border-none bg-transparent p-0 text-content-muted hover:text-foreground";

interface PhotoUploadReminderBannerProps {
  onDismiss: () => void;
}

function DashboardPhotoUploadReminderBanner(
  props: PhotoUploadReminderBannerProps,
) {
  return (
    <Banner
      variant="warning"
      title="Upload photos of your freight for protection"
      actions={
        <div className="self-start">
          <button
            type="button"
            className={dismissButtonClasses}
            onClick={props.onDismiss}
            data-testid="dismiss-photo-upload-reminder"
          >
            <XIcon size={12} weight="bold" />
          </button>
        </div>
      }
    >
      Recent shipments are missing pickup photos. Uploading photos via the QR
      code on your pickup package helps protect you in case of loss or damage
      claims.
    </Banner>
  );
}

export default DashboardPhotoUploadReminderBanner;
